import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import en from './en'

export const messages = {
  'zh-CN': zhCN,
  en,
  fr: { app: 'Espace Jaohui', newBrief: 'Nouveau brief', myBriefs: 'Mes briefs', workbench: 'Espace equipe', members: 'Membres', model: 'Modele', logout: 'Deconnexion', taskList: 'Liste des taches', submit: 'Confirmer et envoyer', addChange: 'Completer la demande', send: 'Envoyer', emptyQueue: 'Aucun Brief soumis', shell: { tasks: 'Taches' } }
}

export const i18n = createI18n({ legacy: false, locale: 'zh-CN', fallbackLocale: 'zh-CN', messages })
